// extracted by mini-css-extract-plugin
export default {"container":"Can_container__mwmUL","text":"Can_text__g-DlV","icon":"Can_icon__+1h+O"};